import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const NOTICE_MENU: PermissionTableRowType = {
  name: '공지사항',
  key: 'NOTICE_MANAGE',
  subRows: [
    {
      name: '상점 공지사항 관리',
      key: PERMISSION_SUBJECTS.STORE_NOTICE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.STORE_NOTICE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '상점 공지사항 등록',
          key: PERMISSION_SUBJECTS.STORE_NOTICE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '상점 공지사항 편집',
          key: PERMISSION_SUBJECTS.STORE_NOTICE,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '상점 공지사항 삭제',
          key: PERMISSION_SUBJECTS.STORE_NOTICE,
          permissions: [PERMISSION_ACTIONS.DELETE],
        },
      ],
    },
    {
      name: '상품 공지사항 관리',
      key: 'productNotice',
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.DELETE],
      subRows: [
        {
          name: '리스트 조회',
          key: 'productNotice',
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '상품 공지사항 상세 조회',
          key: 'productNotice',
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '상품 공지사항 삭제',
          key: 'productNotice',
          permissions: [PERMISSION_ACTIONS.DELETE],
        },
      ],
    },
  ],
};
